import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Gift, UserPlus } from "lucide-react";
import { motion } from "framer-motion";
import { containerVariants, itemVariants } from "@/lib/animations";

const HowItWorks = () => {
    const steps = [
        {
            icon: <UserPlus className="w-12 h-12 text-primary" />,
            title: "Sign Up",
            description: "Sign up using your Roblox username. No password required! We'll verify your account securely."
        },
        {
            icon: <DollarSign className="w-12 h-12 text-primary" />,
            title: "Earn Tokens",
            description: "Complete offers from our partners like Bitlabs and Lootably. Watch videos, take surveys, and more to earn tokens."
        },
        {
            icon: <Gift className="w-12 h-12 text-primary" />,
            title: "Withdraw Robux",
            description: "Exchange your tokens for Robux. We'll automatically purchase your gamepass to send the Robux to your account."
        }
    ];

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.6,
            ease: "easeOut",
          },
        },
        hover: { 
            y: -5,
            transition: { type: "spring", stiffness: 300 } 
        }
    };

    return (
        <motion.section 
            className="py-20 px-4 md:px-8"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className="container mx-auto">
                <motion.h2 variants={itemVariants} className="text-3xl font-bold text-center mb-12">How It Works</motion.h2>
                <motion.div 
                    className="grid grid-cols-1 md:grid-cols-3 gap-8"
                    variants={containerVariants}
                >
                    {steps.map((step, index) => (
                        <motion.div 
                            key={index} 
                            variants={cardVariants} 
                            whileHover="hover"
                            whileTap={{ scale: 0.98 }}
                        >
                            <Card className="glass-effect border-border text-center h-full overflow-hidden transition-all duration-300 relative">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-primary/10 via-primary/0 to-primary/10"
                                    variants={{
                                        initial: { x: "-100%" },
                                        hover: { x: "100%" }, // This is triggered by the parent's whileHover
                                    }}
                                    transition={{ duration: 0.6, ease: "linear" }}
                                />
                                <div className="relative z-10">
                                    <CardHeader>
                                        <motion.div
                                            className="flex justify-center mb-4"
                                            whileHover={{ scale: 1.1, rotate: -5 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            {step.icon}
                                        </motion.div>
                                        <CardTitle>{step.title}</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <p className="text-muted-foreground">{step.description}</p>
                                    </CardContent>
                                </div>
                            </Card>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </motion.section>
    );
};

export default HowItWorks;
